import { Box } from "@mui/material";
import { AddFamilyMemberButton } from "@components/buttons/addFamilyMemberButton/AddFamilyMemberButton";
import { IInOfficeEvent } from "../../../../types/formAssignments/IInOfficeEvent";
import { PendingFormDataToAssignPerPatient } from "../forms/usePendingFormDataToAssign";

interface FamilyMemberSelectorProps {
  selectedEvent: IInOfficeEvent;
  pendingFormDataToAssign: PendingFormDataToAssignPerPatient;
  onFamilyMemberSelect: (patientId: string) => void;
}

export default function FamilyMemberSelector({
  selectedEvent,
  pendingFormDataToAssign: pendingFormDataToAssignFromProps,
  onFamilyMemberSelect,
}: FamilyMemberSelectorProps) {
  const pendingFormDataToAssign = Object.values(
    pendingFormDataToAssignFromProps
  );

  if (pendingFormDataToAssign.length < 2) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "8px",
        alignSelf: "stretch",
        width: "100%",
        maxWidth: "800px",
      }}
    >
      <Box
        sx={{
          fontFamily: "Roboto Condensed",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "700",
          lineHeight: "normal",
          color: "#000",
          textAlign: "center",
        }}
      >
        {"Select the family member you'd like to assign forms to"}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "16px",
          alignSelf: "stretch",
          flexWrap: "wrap",
        }}
      >
        {pendingFormDataToAssign.map(
          ({ inOfficeEvent: { patient }, incompleteForms }) => (
            <AddFamilyMemberButton
              key={patient.id}
              familyMemberName={patient.firstName}
              isSelected={patient.id === selectedEvent.patient.id}
              hasIncompleteForm={incompleteForms.length > 0}
              onClick={() => onFamilyMemberSelect(patient.id)}
            />
          )
        )}
      </Box>
    </Box>
  );
}
